import { Page } from "@/models/page-models/Page";

export const RmReceipt: Page = {
  "path": "rm-receipt",
  "name": "RM Receipt",
  "props": {
    "data": {
      "title": "RM Receipt",
      "printable": "FALSE",
      "url": "rm-receipt",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.forPO",
                  "label": "Purchase Order",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "name": "copyPoData"
                    },
                    {
                      "executionOrder": 2,
                      "name": "initialiseReceipts"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.posPendingReceipts.data",
                  "itemText": "_id",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,purchaseOrder,{{__item}})"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "fetchedData.selectedPoData._id",
                  "label": "PO#",
                  "showIf": "{{formData.forPO}}"
                },
                {
                  "type": "label",
                  "label": "PO Date",
                  "showIf": "{{formData.forPO}}",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{formData.createdAt}})",
                },
                {
                  "type": "label",
                  "variable": "fetchedData.selectedPoData.supplier.name",
                  "label": "Supplier",
                  "showIf": "{{formData.forPO}}"
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "arrayGroup",
          "variable": "formData.receivedGoods",
          "label": "Received Raw Materials",
          "disabled": "FALSE",
          "showIf": "{{formData.receivedGoods}}",
          "arrayItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "id",
                  "label": "Material",
                  "disabled": "TRUE",
                  "inputType": "formula",
                  "formula": "fn(HELPER_FN,goodsName,{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.rawMaterial}})"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "unitQuantity",
                  "label": "Total Quantity",
                  "labelType": "formula",
                  "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.rawMaterial.rawMaterialUnit}},'),==,'SQM'),{{fn(STANDARD_FUNCTIONS,kgToSQM,{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.unitQuantity}},{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.rawMaterial}})}},{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.unitQuantity}})",
                  "filterType": "unit",
                  "filterParam": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.rawMaterial.rawMaterialUnit}},'),==,'SQM'),SQM,KG)"
                },
                {
                  "type": "label",
                  "variable": "receivedQuantity",
                  "label": "Received Quantity",
                  "labelType": "formula",
                  "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.rawMaterial.rawMaterialUnit}},'),==,'SQM'),{{fn(STANDARD_FUNCTIONS,kgToSQM,{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.receivedQuantity}},{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.rawMaterial}})}},{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.receivedQuantity}})",
                  "filterType": "unit",
                  "filterParam": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.rawMaterial.rawMaterialUnit}},'),==,'SQM'),SQM,KG)"
                },
                {
                  "type": "label",
                  "variable": "balanceQuantity",
                  "label": "Balance Quantity",
                  "labelType": "formula",
                  "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.rawMaterial.rawMaterialUnit}},'),==,'SQM'),{{fn(STANDARD_FUNCTIONS,kgToSQM,fn(SUBTRACT,{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.unitQuantity}},{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.receivedQuantity}}),{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.rawMaterial}})}},fn(SUBTRACT,{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.unitQuantity}},{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.receivedQuantity}}))",
                  "filterType": "unit",
                  "filterParam": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedPoData.purchasedRMs.{{__index}}.rawMaterial.rawMaterialUnit}},'),==,'SQM'),SQM,KG)"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "arrayGroup",
                  "variable": "entries",
                  "label": "Material",
                  "disabled": "FALSE",
                  "arrayItems": [
                    {
                      "name": "1",
                      "pageItems": [
                        {
                          "type": "input",
                          "variable": "weight",
                          "label": "Weight",
                          "unit": "KG",
                          "disabled": "FALSE"
                        },
                        {
                          "type": "input",
                          "variable": "id",
                          "label": "Roll #/Pallet #",
                          "disabled": "FALSE"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ],
          "disableAddDelete": true
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Submit",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "submitRmReceipt"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ]
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "getPosPendingReceipts"
      }
    ],
    "functions": [
      {
        "name": "getPosPendingReceipts",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/purchaseorder/checkWarehouse?type=Raw Material",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.posPendingReceipts"
      },
      {
        "name": "copyPoData",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedPoData"
      },
      {
        "name": "initialiseReceipts",
        "type": "fnCreateArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.selectedPoData.purchasedRMs",
        "arg2Key": "destinationVariable",
        "arg2Value": "formData.receivedGoods",
        "arg3Key": "arrayTransformationFn",
        "arg3Value": "createInitialMaterialData"
      },
      {
        "name": "createInitialMaterialData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "id": "{{__selectedObject.rawMaterial._id}}",
          "entries": "[{}]"
        },
        "useFormula": true
      },
      {
        "name": "submitRmReceipt",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/purchaseorder/rmReceipt",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      }
    ]
  },
  "forRole": "CUSTOMER_SERVICE_MANAGER,CUSTOMER_SERVICE_INBOUND_WAREHOUSE",
  "visible": true
}